enum RouteName {
    Main = 'Main',
    Prompt = 'Prompt',
    Search = 'Search',
    Study = 'Study',
    Course = 'Course',
    Chapter = 'Chapter',
    Compete = 'Compete',
    Challenge = 'Challenge',
    Category = 'Category',
    Profile = 'Profile',
    ProfilePrompts = 'ProfilePrompts',
    ProfileFavorites = 'ProfileFavorites',
    ProfileAchievements = 'ProfileAchievements',
    ProfileRating = 'ProfileRating',
    NewPrompt = 'NewPrompt',
    UserProfile = 'UserProfile',
    NewPromptSuccess = 'NewPromptSuccess',
    NewPromptFailure = 'NewPromptFailure',
    NotFound = 'NotFound',
    NewPromptStatus = 'NewPromptStatus',
    CompeteRules = 'CompeteRules',
    NewRules = 'NewRules',
    PromoResearch = 'PromoResearch',
}

export const RoutePaths: Record<RouteName, string> = {
    Main: '/',
    Prompt: '/prompts',
    Search: '/search',
    Study: '/study',
    Course: '/course',
    Chapter: '/chapter',
    Compete: '/compete',
    Challenge: '/compete',
    Category: '/c',
    Profile: '/profile',
    ProfilePrompts: '/profile/prompts',
    ProfileFavorites: '/profile/favorites',
    ProfileRating: '/profile/rating',
    ProfileAchievements: '/profile/achievements',
    UserProfile: '/users',
    NewPrompt: '/new',
    NewPromptSuccess: '/new-success',
    NewPromptFailure: '/new-failure',
    NotFound: '/not-found',
    NewPromptStatus: '/check-status',
    CompeteRules: '/compete/rules',
    NewRules: '/new/rules',
    PromoResearch: '/promo/research',
} as const;

export const ApplicationRoutes: Record<RouteName, string> = {
    Main: RoutePaths.Main,
    Prompt: `${RoutePaths.Prompt}/:slug`,
    Search: RoutePaths.Search,
    Study: RoutePaths.Study,
    Course: `${RoutePaths.Course}/:id`,
    Chapter: `${RoutePaths.Course}/:courseId/chapter/:chapterId`,
    Compete: RoutePaths.Compete,
    Challenge: `${RoutePaths.Challenge}/:slug`,
    Category: `${RoutePaths.Category}/:category`,
    Profile: RoutePaths.Profile,
    ProfilePrompts: RoutePaths.ProfilePrompts,
    ProfileFavorites: RoutePaths.ProfileFavorites,
    ProfileAchievements: RoutePaths.ProfileAchievements,
    ProfileRating: RoutePaths.ProfileRating,
    UserProfile: `${RoutePaths.UserProfile}/:publicId`,
    NewPrompt: RoutePaths.NewPrompt,
    NewPromptSuccess: RoutePaths.NewPromptSuccess,
    NewPromptFailure: RoutePaths.NewPromptFailure,
    NotFound: RoutePaths.NotFound,
    NewPromptStatus: `${RoutePaths.NewPromptStatus}/:slug`,
    CompeteRules: RoutePaths.CompeteRules,
    NewRules: RoutePaths.NewRules,
    PromoResearch: RoutePaths.PromoResearch,
} as const;

export const ProfileNestedRoutes = {
    Prompts: 'prompts',
    Favorites: 'favorites',
    Achievements: 'achievements',
    Rating: 'rating',
} as const;
